module.exports = __webpack_public_path__ + "img/auth-img.59cb9429.svg";